<script>
  import resources from './resources'

  export default {
    name: 'company-statitics',
    mixins: [resources]
  }
</script>

<template lang="pug">
  div
    .stats-row.stats-row-profile.text-right
      .stat-item
        h6.name(v-if="totalProfessional > 1") Profissionais
        h6.name(v-if="totalProfessional <= 1") Profissional
        p.value.text-right
          strong {{ totalProfessional }}

      .stat-item
        h6.name(v-if="totalAgendas > 1") Agendas
        h6.name(v-if="totalAgendas <= 1") Agenda
        p.value.text-right
          strong {{ totalAgendas }}


      .stat-item
        h6.name(v-if="totalAgendaSchedules > 1") Horários
        h6.name(v-if="totalAgendaSchedules <= 1") Horário
        p.value.text-right
          strong {{ totalAgendaSchedules }}


</template>
<style scoped>
@media (min-width:992px) {
.stats-row {
    margin-bottom: 15px
}
.text-right {
    text-align: right !important
}
.stats-row-profile .stat-item .value {
    font-size: 28px;
    font-weight: 300;
    color: #898989;
}
.stat-item {
    display: inline-block;
    padding-right: 15px
}

.stat-item+.stat-item {
    padding-left: 15px;
    border-left: 1px solid rgba(0, 0, 0, 0.1)
}

.stat-item .name {
    margin-bottom: 2px;
    margin-top: 10px
}

.stat-item.stat-item-mini-chart {
    position: relative;
    top: -12px;
    padding-left: 0;
    border-left: none
}
}

@media (max-width: 768px){
  .stats-row {
    margin-top: 10px
  }
  .text-right {
      text-align: left !important
  }
  .stat-item .value {
      margin-left: 5px;
      font-size: 20px;
      font-weight: 300;
      color: #898989;
  }
  .stat-item p {
    padding: 0px;
  }
  .stat-item {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    display: inline-block;
    padding-right: 15px;
  }

  .stat-item .name {
      margin-bottom: 2px;
      margin-top: 0px;
      font-size: 10px;
      margin-left: 5px;
  }
}

@media (max-width: 767px){
  .stats-row {
    margin-top: 10px
  }
  .text-right {
      text-align: left !important
  }
  .stat-item .value {
      margin-left: 5px;
      font-size: 28px;
      font-weight: 300;
      color: #898989;
  }
  .stat-item {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    display: inline-block;
    padding-right: 15px;
  }

  .stat-item .name {
      margin-bottom: 2px;
      margin-top: 0px;
      font-size: 10px;
      margin-left: 5px;
  }
}
</style>




// WEBPACK FOOTER //
// src/app/patient/profile-company/components/statistics/index.vue